module.exports = __webpack_public_path__ + "static/media/products_dark.85dc6858.jpg";